'use strict';
import isString from 'lodash/isString';

PopupService.$inject = [
  '$rootScope',
  '$interval',
  '$translate',
  '$toast',
];

export function PopupService(
  $rootScope,
  $interval,
  $translate,
  $toast,
) {
  const service = this;
  service.countdownConfirm = countdownConfirm;
  service.textInputConfirm = textInputConfirm;
  service.checkboxConfirm = checkboxConfirm;

  /**
   *
   * See general config see the show documentation.
   * Does not support scope property. Always uses an isolate scope.
   * @param config.duration
   * @returns {*}
   */
  function countdownConfirm(config) {
    const scope = $rootScope.$new(true);
    const buttons = constructButtons();
    config.duration = config.duration || 3;
    // This instance instantiation modifies scope to add behavior to to the template
    const controller = new CountdownConfirmController(scope, $interval, $translate, config.duration, buttons);
    return service.show({
      template: config.template,
      cssClass: config.cssClass,
      title: config.title,
      subTitle: config.subTitle,
      scope: scope,
      buttons: buttons,
    });

    function constructButtons() {
      return [
        {
          text: $translate.instant('default.cancel.label'),
          type: 'button-default',
        },
        {
          /* TODO: need a way to actually disable the button until the timer expires */
          text: '',
          type: 'button-positive',
          onTap: function (e) {
            if (scope.popup.duration > 0) {
              e.preventDefault();
            } else {
              return true;
            }
          },
        },
      ];
    }
  }

  /**
   *
   * See general config see the show documentation.
   * Does not support scope property. Always uses an isolate scope.
   * @param config.body
   * @param config.confirmText
   * @returns {*}
   */
  function textInputConfirm(config) {
    const bodyText = isString(config.body) ? config.body : '';
    const scope = $rootScope.$new(true);
    scope.popup = {
      confirmText: '',
    };
    return service.show({
      /* eslint-disable-next-line max-len */
      template: '<div class="text-input-confirm-body">' + bodyText + '</div><input type="text" style="text-align: center;" ng-model="popup.confirmText">',
      cssClass: config.cssClass,
      title: config.title,
      subTitle: config.subTitle,
      scope: scope,
      buttons: [
        {
          text: $translate.instant('default.cancel.label'),
          type: 'button-default',
        },
        {
          text: $translate.instant('default.okay.label'),
          type: 'button-positive',
          onTap: function (e) {
            if (scope.popup.confirmText === config.confirmText) {
              return true;
            } else {
              e.preventDefault();

              $toast.showI18nMessage({
                messageId: 'popup.confirm.input.invalid.message',
                messageParams: {rejectedValue: scope.popup.confirmText, expectedValue: config.confirmText},
                type: 'error',
              });
            }
          },
        },
      ],
    });
  }

  /**
   * @typedef {Object} CheckboxConfirmResponse
   * @property {boolean} confirm - true if user clicks OK
   * @property {boolean} option - true if user checks the option box
   */

  /**
   *
   * See general config see the show documentation.
   * Does not support scope property. Always uses an isolate scope.
   * @param {string} config.body
   * @param {string} config.optionLabel
   * @param {boolean} [config.optionDefault=false]
   * @param {string} [config.okayLabel='default.okay.label']
   * @param {string} [config.cancelLabel='default.cancel.label']
   * @returns {Promise.<false|CheckboxConfirmResponse>}
   */
  function checkboxConfirm(config) {
    const scope = $rootScope.$new(true);
    scope.popup = {
      option: config.optionDefault === true,
    };
    return service.show({
      template: '<div class="text-input-confirm-body">' + config.body + '</div>' +
      '<div><ion-checkbox ng-model="popup.option">' + config.optionLabel + '</ion-checkbox></div>',
      cssClass: config.cssClass,
      title: config.title,
      subTitle: config.subTitle,
      scope: scope,
      buttons: [
        {
          text: $translate.instant(config.cancelLabel || 'default.cancel.label'),
          type: 'button-default',
        },
        {
          text: $translate.instant(config.okayLabel || 'default.okay.label'),
          type: 'button-positive',
          onTap: function (e) {
            return {
              confirm: true,
              option: scope.popup.option,
            };
          },
        },
      ],
    });
  }
}

function CountdownConfirmController($scope, $interval, $translate, duration, buttons) {
  const vm = $scope.popup = this;

  vm.confirmEnabled = false;
  vm.duration = duration;

  vm.getConfirmLabel = getConfirmLabel;

  // TODO: may need to improve the accuracy of this using startDate = new Date() and delta comparison
  buttons[1].text = getConfirmLabel();
  const timer = $interval(() => {
    vm.duration--;

    buttons[1].text = getConfirmLabel();

    if (vm.duration === 0) {
      vm.confirmEnabled = true;
      cleanup();
    }
  }, 1000);

  $scope.$on('$destroy', cleanup);

  function getConfirmLabel() {
    const duration = vm.duration;
    const durationLabel = duration < 1 ? '' : ' (' + vm.duration + ')';

    return $translate.instant('default.okay.label') + durationLabel;
  }

  function cleanup() {
    $interval.cancel(timer);
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/popup/PopupService.js